import React, { useEffect } from 'react';

// Utils
import { useCookies } from 'react-cookie';
import { useAppContext } from '../../store/AppContext';
import useStorage from '../../utils/hooks/useStorage';

// Components
import ResetPasswordForm from '../../components/auth/ResetPasswordForm/ResetPasswordForm';

function ResetPassword() {
  const [{ user }, dispatch] = useAppContext();
  const { removeItem } = useStorage();

  const [,, removeCookie] = useCookies(['jwt']);

  useEffect(() => {
    if (user) dispatch({ type: 'SET_USER', payload: null });
    removeCookie('jwt', { path: '/' });
    removeItem('user');
  }, []);

  return (
    <div className="d-flex a-center j-center full-view-height mobile-a-stretch">
      <ResetPasswordForm />
    </div>
  );
}

export default ResetPassword;
